import { INACTIVITY_LOGOUT_FLAG, INACTIVITY_LOGOUT_MESSAGE } from "./inactivityTimeout";

let logoutInFlight = false;

export const resetLogoutGuard = () => {
  logoutInFlight = false;
};

export const beginLogoutOnce = () => {
  if (logoutInFlight) {
    return false;
  }
  logoutInFlight = true;
  return true;
};

export const getPartnerLoginPath = (partnerID = localStorage.getItem("partnerID")) =>
  partnerID ? `/login/${partnerID}` : "/login";

const clearRejectedCookieConsent = () => {
  const consent = document.cookie.replace(
    /(?:(?:^|.*;\s*)cookieConsent\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
  if (consent === "rejected") {
    document.cookie = "cookieConsent=; max-age=0; path=/";
  }
};

export const clearAuthSession = ({ inactivityLogout = false } = {}) => {
  const partnerID = localStorage.getItem("partnerID");
  clearRejectedCookieConsent();
  localStorage.clear();
  sessionStorage.clear();
  if (partnerID) {
    localStorage.setItem("partnerID", partnerID);
  }
  if (inactivityLogout) {
    localStorage.setItem(INACTIVITY_LOGOUT_FLAG, "true");
  }
  return getPartnerLoginPath(partnerID);
};

export const consumeInactivityLogoutMessage = () => {
  const flag = localStorage.getItem(INACTIVITY_LOGOUT_FLAG);
  if (flag === "true") {
    localStorage.removeItem(INACTIVITY_LOGOUT_FLAG);
    return INACTIVITY_LOGOUT_MESSAGE;
  }
  return null;
};
